import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Form } from 'react-bootstrap'
import './Checkbox.module.scss'

const propTypes = {
  /**
   * If true, checkbox will be styled as indeterminate
   */
  indeterminate: PropTypes.bool,
  /**
   * Class to modify default styles
   */
  className: PropTypes.string,
  /**
   * Label of the checkbox
   */
  label: PropTypes.node,
}

/**
 * Checkbox — react-bootstrap `Form.Check` (Bootstrap 5 / `.form-check*` markup).
 */
function Checkbox(props) {
  const { className = '', indeterminate = false, label = '', ...rest } = props ?? {}

  return (
    <Form.Check
      type="checkbox"
      label={label}
      className={clsx('Uic-Checkbox-base', className)}
      ref={(input) => {
        if (input) input.indeterminate = indeterminate // eslint-disable-line no-param-reassign
      }}
      {...rest}
    />
  )
}

Checkbox.propTypes = propTypes

export default Checkbox
